import { PageHeader } from "@/components/Shared";
import { PAGES, ROLE_VIEWS, ROLE_NAMES } from "@/config/roleViews";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Eye, Check } from "lucide-react";

// Live review sheet for Murali / Nitin: generated from config/roleViews.js,
// so it can never drift from what the app actually does.
export default function RoleViews() {
  const { setViewAs } = useAuth();
  const nav = useNavigate();
  const pages = Object.keys(PAGES).filter((p) => p !== "/views");

  return (
    <div>
      <PageHeader subtitle="Admin · review sheet" title="Role Views" testId="roleviews-header" />
      <div className="p-8 space-y-6">
        <p className="text-sm text-neutral-600 max-w-3xl">
          Every view below is one entry in <code>frontend/src/config/roleViews.js</code>. Click
          <b> Preview</b> to see the app exactly as that role sees it (display only; the server still applies
          your admin rights). “Inherits” is the core role whose server permissions the view uses.
        </p>

        <div className="border border-neutral-200 bg-white overflow-auto">
          <table className="w-full text-sm" data-testid="roleviews-matrix">
            <thead className="bg-neutral-50 label-caps">
              <tr>
                <th className="text-left px-4 py-2.5">View</th>
                <th className="text-left px-4 py-2.5">Inherits</th>
                <th className="text-left px-4 py-2.5">Money?</th>
                <th className="text-left px-4 py-2.5">Lands on</th>
                {pages.map((p) => (
                  <th key={p} className="px-2 py-2.5 text-center text-[10px] whitespace-nowrap">{PAGES[p]}</th>
                ))}
                <th className="px-4 py-2.5" />
              </tr>
            </thead>
            <tbody>
              {ROLE_NAMES.map((r) => {
                const v = ROLE_VIEWS[r];
                return (
                  <tr key={r} className="border-t border-neutral-100 align-top">
                    <td className="px-4 py-3">
                      <div className="font-medium">{v.label}</div>
                      <div className="text-xs text-neutral-500 max-w-xs">{v.summary}</div>
                    </td>
                    <td className="px-4 py-3 text-xs">{v.base === r ? "core role" : v.base.replace("_", " ")}</td>
                    <td className="px-4 py-3 text-xs">{v.finance ? "yes" : "no"}</td>
                    <td className="px-4 py-3 text-xs font-mono-num">{v.landing}</td>
                    {pages.map((p) => (
                      <td key={p} className="px-2 py-3 text-center">
                        {(r === "admin" || v.nav.includes(p)) ? <Check size={14} className="inline text-emerald-700" /> : <span className="text-neutral-300">·</span>}
                      </td>
                    ))}
                    <td className="px-4 py-3">
                      {r !== "admin" && (
                        <button
                          data-testid={`preview-${r}`}
                          onClick={() => { setViewAs(r); nav("/"); }}
                          className="flex items-center gap-1 text-xs border border-neutral-200 px-2 py-1.5 hover:bg-neutral-50 rounded-sm"
                        >
                          <Eye size={12} /> Preview
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
